import React from 'react';
import { DeepDive } from 'src/features/DA/components/templates/DeepDive';
import { Page } from '../../components/molecules/Page';
import { DAKeyMetrics } from '../../features/DA/components/organisms/DAKeyMetrics';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const DeepDivePage: React.FC = () => {
  return (
    <Page
      filterBar={<FilterBar includeBenchmark />}
      pageTitle="Campaign Groups"
      pageSubtitle="Track your project and goal with full information"
      keyMetrics={<DAKeyMetrics />}
      extraButtons={<GenAIActionButtons />}>
      <DeepDive />
    </Page>
  );
};
